module.exports = __webpack_public_path__ + "static/media/Shiny Dashboard Built With Fluent UI.b4cde1fa.mp4";